import type { AnalysisRow } from "../shared/analysisListTypes";

// Fallback de lista da análise (usado quando a API não retorna solicitações para o ano).
export const AVAILABLE_YEARS_FALLBACK = [2026, 2025];

export const getFallbackRowsByYear = (year: number): AnalysisRow[] => [
  {
    id: year * 1000 + 1,
    solicitacao: "1ª Solicitação (fallback)",
    situacao: "Documentação Enviada",
    envioDocumentacao: `${year}-03-31T12:02:00`,
    ultimaAtualizacao: `${year}-03-31T12:02:00`,
    solicitacaoAdequacao: null,
    adequacaoDocumentacao: null,
    conclusaoAnalise: null,
    ano: year,
    idQuestionarioResposta: null,
    idSindicato: null,
    historicoHabilitado: false,
    cnpj: "00000000000191",
    sigla: "FALLBACK",
    rowKey: `fallback-${year}`,
  },
];
